import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export interface PhotoItem {
  id: string;
  url: string;
  caption: string;
  created_at: string;
}

export async function fetchPhotos(): Promise<PhotoItem[]> {
  const res = await axios.get<PhotoItem[]>(`${API}/photos`);
  return res.data;
}

export async function uploadPhoto(file: File, caption: string): Promise<PhotoItem> {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("caption", caption);
  const res = await axios.post<PhotoItem>(`${API}/photos`, fd);
  return res.data;
}

export async function deletePhoto(id: string): Promise<void> {
  await axios.delete(`${API}/photos/${id}`);
}
